module.exports = __webpack_public_path__ + "static/media/home-payment-img-1.60a596c2.svg";